<template>
  <div class="section-container">
    <div class="section-top">
      <div class="flex items-center">
        <p class="section-title mr-3">{{ title }}</p>
        <sf-icon @click="openModal" size="lg" :icon="['fas', 'info-circle']" :style="{ cursor: 'pointer', marginTop: '-3px' }" />
      </div>
      <p class="section-number">{{ step }}/{{ totalSteps }}</p>
    </div>
    <div class="section-bottom">
      <div class="flex justify-between pb-4" v-html="cardContent"></div>

      <ul class="flex flex-wrap ml-[-0.5rem] mt-4">
        <li
          v-for="option of options"
          :key="option.id"
          class="flex flex-col justify-between w-full md:w-1/2 pb-3 md:px-2 lg:w-1/3 lg:px-2 lg:pb-4 box-border cursor-pointer"
          @click="select(option)"
        >
          <div
            :style="`background-image: url('${optionImage(option)}');`"
            class="flex justify-end w-full pt-[60%] md:pt-[63%] lg:pt-28 pb-2 bg-gray-500 bg-cover bg-no-repeat border-4 border-gray-200"
            :class="{ 'border-yellow-400': isSelected(option) }"
          >
            <sf-icon
              size="lg"
              :icon="['fas', 'search-plus']"
              :style="{
                cursor: 'pointer',
                color: '#FAC431',
                textShadow: '-1px -1px 0 #000,  1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
                marginRight: '7px',
              }"
              @click="showLightbox(option)"
            />
          </div>
          <div class="bg-gray-200 text-center py-2 px-1 text-sm capitalize" :class="{ 'bg-yellow-400': isSelected(option) }">
            {{ option.variationName || option.name || '' }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getAttributeValue } from "./plentyHelpers";
import { fetchCategoryContent } from "./Helpers";

export default {
  name: "MaterialColor",
  props: ["category", "step", "totalSteps"],

  data() {
    return {
      modalContent: "",
      title: "Stofffarbe",
      cardContent: "",
    };
  },

  async created() {
    let { modalContent, title, cardContent } = await this.fetchCategoryContent(this.category, this.$setPreview);
    this.modalContent = modalContent;
    if (title) this.title = title;
    if (cardContent) this.cardContent = cardContent;
  },

  computed: {
    ...mapState("materialColor/", {
      selection: (state) => state.selection,
      defaultSelection: (state) => state.defaultSelection,
      options: (state) => state.options,
    }),
  },

  methods: {
    fetchCategoryContent,

    ...mapMutations("materialColor/", {
      setSelection: "setSelection",
    }),

    ...mapMutations("lightbox/", {
      setImages: "setImages",
      setVisibility: "setVisibility",
    }),

    optionImage(option, size = "middle") {
      if (!option.images) return "";
      if (!option.images[0]) return "";
      if (size === "large") return option?.images[0].url;
      return option?.images[0].urlMiddle;
    },

    optionName(option) {
      return getAttributeValue(option, "Tuchfarbe").replaceAll("_", " ");
    },

    select(option) {
      this.setSelection(option);
    },

    isSelected(option) {
      return this.selection.id === option.id;
    },

    showLightbox(option) {
      this.setImages(this.optionImage(option, "large"));
      this.setVisibility(true);
    },

    openModal() {
      this.$store.commit("modal/openModal")
      this.$store.dispatch("modal/setBody", this.modalContent);
      this.$store.dispatch("modal/setTitle", this.title);
    },
  },

  watch: {
    options(options) {
      if (options.length > 0 && !this.selection.id) {
        let option = options[0];

        if (this.defaultSelection) {
          let defaultSelection = options.find((option) => option.id == this.defaultSelection);
          if (defaultSelection) option = defaultSelection;
        }

        this.select(option);
      }
    },
  },
};
</script>

<style></style>
